export const sessionArr = [
  {
    id: 113,
    name: "Weekend Evenings",
    first_seating: "17:00:00",
    last_seating: "22:00:00",
    type: 1,
    availability_type: 2,
    total_shift_covers: 50,
    status: 1,
    notes: null,
    type_1_weekly:
      '{"Mon":"0","Tue":"0","Wed":"0","Thu":"0","Fri":"1","Sat":"1","Sun":"0"}',
    durationas_set: "30,30,30,30,30,30,30,30",
    type_2_start_date: null,
    type_2_end_date: null,
    a_type_total_cover: 50,
    a_type_pacing_set:
      '[{"key":"17:00-18:00","val":"50"},{"key":"18:00-19:00","val":"50"},{"key":"19:00-20:00","val":"50"},{"key":"20:00-21:00","val":"50"},{"key":"21:00-22:00","val":"50"}]',
    store_id: 470,
    created_at: "2022-06-17 17:01:46",
    updated_at: "2022-10-21 11:44:02",
    deleted_at: null,
    deposit: 0,
    deposit_type: 1,
    buffer_time: 1,
    accurate_last_seating: 1,
    is_refund_deposit: 0,
    refund_deposit_days: 0,
    is_open_allergen: 0,
    is_holding_time: 0,
    has_table: 1,
  },
  {
    id: 114,
    name: "Lunch",
    first_seating: "11:00:00",
    last_seating: "14:00:00",
    type: 1,
    availability_type: 2,
    total_shift_covers: 50,
    status: 1,
    notes: null,
    type_1_weekly:
      '{"Mon":"0","Tue":"0","Wed":"0","Thu":"0","Fri":"1","Sat":"1","Sun":"0"}',
    durationas_set: "30,30,30,30,30,30,30,30",
    type_2_start_date: null,
    type_2_end_date: null,
    a_type_total_cover: 50,
    a_type_pacing_set:
      '[{"key":"17:00-18:00","val":"50"},{"key":"18:00-19:00","val":"50"},{"key":"19:00-20:00","val":"50"},{"key":"20:00-21:00","val":"50"},{"key":"21:00-22:00","val":"50"}]',
    store_id: 470,
    created_at: "2022-06-17 17:01:46",
    updated_at: "2022-10-21 11:44:02",
    deleted_at: null,
    deposit: 0,
    deposit_type: 1,
    buffer_time: 1,
    accurate_last_seating: 1,
    is_refund_deposit: 0,
    refund_deposit_days: 0,
    is_open_allergen: 0,
    is_holding_time: 0,
    has_table: 1,
  },
];

export const timeArr = [
  {
    time: "17:00",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "17:15",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "17:30",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "17:45",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "18:00",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "18:15",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "18:30",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "18:45",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "19:00",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "19:15",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "19:30",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "19:45",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "20:00",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "20:15",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "20:30",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "20:45",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "21:00",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "21:15",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "21:30",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "21:45",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
  {
    time: "22:00",
    show: 1,
    table_id:
      "43,180,202,205,208,217,247,248,270,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,618,",
  },
];



// WEBPACK FOOTER //
// ./src/assets/reserveTime.js